import { useCallback } from 'react';
import { ExportStatus } from '@weave/schema-gen-ts/dist/shared/phone/v1/callrecord/enums.pb';
import { PhoneCallsApi } from '@frontend/api-phone-calls';
import { largeDownloadsRef } from '@frontend/file-download-helper';
import { saveCSV } from '@frontend/media-helpers';
import { useAlert } from '@frontend/design-system';

export const useExportCallRecordUpdater = () => {
  const alert = useAlert();
  const handleExportCallRecordUpdate = useCallback(
    async ({ id, downloadLink, status }: { id: string; downloadLink: string; status: ExportStatus }) => {
      largeDownloadsRef.current?.handleClearEvent(id);
      if (status === ExportStatus.EXPORT_STATUS_FAILED) {
        alert.error(`Failed to download CSV.`);
        return;
      }
      if (status === ExportStatus.EXPORT_STATUS_COMPLETED && !!downloadLink) {
        try {
          await saveCSV(downloadLink, 'call-records-export');
          alert.success('Successfully downloaded CSV.');
          PhoneCallsApi.updateExportCallRecordState({
            exportId: id,
            reportDownloaded: { value: true },
          });
        } catch (error) {
          alert.error('Failed to download CSV.');
        }
      } else if (status === ExportStatus.EXPORT_STATUS_COMPLETED && !downloadLink) {
        alert.error('Failed to download CSV.');
      }
    },
    [alert]
  );

  return { handleExportCallRecordUpdate };
};
